export const Variables = {
    color: {
        black: '#000',
        primary: '#222222',
        cocoa: '#3D332E',
        warmGrey: '#B8AD9E',
        lightWarmGrey: '#F0E8DE',
        white: '#FFFFFF',
        lightGrey: '#EFE9DA',
        border: '#807770',
        grey: '#9D9D9D',
        secondary: '#333333',
        background: '#222222',
        gold: '#222222',
        red: '#d55961',
        body: '#F0E8DE',
        pazola: '#14323C',
        pazolaGold: '#C8965A',
        pazolaKarry: '#FFDCC8'
    },
    font: {
        body: `'MessinaSans', serif`,
        title: `'Roman Grotesque', serif`,
        button: `'MessinaSans', sans-serif`,
        bodyBold: `'MessinaSansBold' , sans-serif`
    },
}
